export default __webpack_public_path__ + "static/media/avatarIntro.ee50865a.gif";